export default __webpack_public_path__ + "static/503-10388ef9e7df6a22103dd28af18e4c74.png";